/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  // Video player with custom play button functionality
  function initVideoPlayers() {
    // Find all video containers
    const videoElements = document.querySelectorAll('.video');

    if (videoElements.length === 0) return;

    videoElements.forEach((container) => {
      const videoElement = container.querySelector('video');
      const playButton = container.querySelector('.video__play');

      if (!videoElement || !playButton) return;

      // Function to play video and hide button
      function playVideo() {
        videoElement
          .play()
          .then(() => {
            playButton.style.opacity = '0';
            playButton.style.visibility = 'hidden';
          })
          .catch((error) => {
            console.error('Error playing video:', error);
          });
      }

      // Function to pause video and show button
      function pauseVideo() {
        videoElement.pause();
        playButton.style.opacity = '1';
        playButton.style.visibility = 'visible';
      }

      // Play button click event
      playButton.addEventListener('click', (e) => {
        e.stopPropagation();
        playVideo();
      });

      // Video click event for toggling play/pause
      videoElement.addEventListener('click', () => {
        if (videoElement.paused) {
          playVideo();
        } else {
          pauseVideo();
        }
      });

      // When video ends, show the play button again
      videoElement.addEventListener('ended', () => {
        pauseVideo();
        videoElement.currentTime = 0;
      });
    });
  }

  // Initialize when DOM is fully loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVideoPlayers);
  } else {
    initVideoPlayers();
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
